function getCurrencyCode(currencyCode) {
    const currencySymbols = {
        "USD": "$",
        "FJD":"$",
        "EUR": "€",
        "JPY": "¥",
        "GBP": "£",
        "AUD": "$",
        "CAD": "$",
        "CHF": "Fr",
        "CNY": "¥",
        "SEK": "kr",
        "NZD": "$",
        "KRW": "₩",
        "SGD": "$",
        "NOK": "kr",
        "MXN": "$",
        "INR": "₹",
        "RUB": "₽",
        "ZAR": "R",
        "BRL": "R$",
        "TRY": "₺",
        "HKD": "HK$",
        "IDR": "Rp",
        "ISK": "kr",
        "PHP": "₱",
        "DKK": "kr",
        "PLN": "zł",
        "HUF": "Ft",
        "CZK": "Kč",
        "THB": "฿",
        "MYR": "RM",
        "HRK": "kn",
        "RON": "lei",
        "ILS": "₪",
        "CLP": "$",
        "AED": "د.إ",
        "COP": "$",
        "SAR": "﷼",
        "BGN": "лв",
        "PKR": "₨",
        "EGP": "£",
        "DZD": "د.ج",
        "KWD": "د.ك",
        "QAR": "﷼",
        "KES": "KSh",
        "VND": "₫",
        "ARS": "$",
        "TWD": "NT$",
        "BDT": "৳",
        "NPR": "₨",
        "IQD": "ع.د",
        "COP": "COL$",
        "LKR": "Rs",
        "UGX": "USh",
        "GHS": "GH₵",
        "RON": "RON",
        "MAD": "د.م.",
        "UZS": "so'm"
      };

    return currencySymbols[currencyCode] || "";
}

// // 示例用法
// console.log(getCurrencyCode("USD")); // 输出 "$"
// console.log(getCurrencyCode("EUR")); // 输出 "€"
// console.log(getCurrencyCode("JPY")); // 输出 "Unknown"，因为日元的符号不在列表中